<template>
    <div class="navigation dashed-space-top">
        <router-link class="item" to="/conversations">
            <i class="fas fa-comments text-3xl"></i>
        </router-link>
        <router-link class="item" to="/conversations-day">
            <i class="fas fa-calendar-day text-3xl"></i>
        </router-link>
        <router-link class="item" :to="{path: '/profil/' + user.id}">
            <i class="fas fa-user text-3xl"></i>
        </router-link>
    </div>
</template>

<script>
export default {
    name: "navigation",
    computed: {
        user: {
            get() {
                return this.$store.getters.currentAppUserData;
            },
            set(value) {
                this.$store.dispatch("storeUser", {
                    user: value
                });
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.navigation {
    position: fixed;
    bottom: 0;
    height: 60px;
    width: 100%;
    background-color: #ffffff;
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    align-items: center;
    z-index: 9999999999999999;
}
.item {
    width: 32%;
}
</style>
